import moment from "moment";
import * as globalUtils from "../../../helpers/utils";

export const buildTravelProposalRequest = (data, language, homeInsurance) => {
  const { travelDetails, applicants } = data;
  const isLessThan180Days =
    moment(travelDetails.returnDate).diff(
      moment(travelDetails.deptDate),
      "d"
    ) <= 180;
  let restApplicants = [];
  if (applicants.applicants && applicants.applicants.length) {
    restApplicants = applicants.applicants.map((ele) => {
      return {
        premiumAmount: null,
        dob: ele.dobGreg,
        idnumber: ele.nationalId,
        relationCode: "Applicant",
        name: globalUtils.isArabic(language)
          ? ele.fullNameArabic
          : ele.fullNameEnglish,
      };
    });
  }

  const duration = moment(travelDetails.returnDate).diff(
    moment(travelDetails.deptDate),
    "days"
  );

  return {
    duration: duration,
    PromotionalFactors: [
      {
        UTMTag: "",
        promotionalCode: travelDetails.promoCode || "",
        openFieldOne: "",
        openFieldTwo: "",
      },
    ],
    isTpremium: travelDetails.productCode === "US" && duration <= 180
      ? "Y"
      : "N",
    returnDate: travelDetails.returnDate,
    featureCode: "",
    productCode: isLessThan180Days ? "ST" : "AN",
    upgradePlan: false,
    promoCode: travelDetails.promoCode || "",
    ApplicantDetails: [
      {
        premiumAmount: null,
        dob: applicants.self.dobGreg,
        idnumber: applicants.self.nationalId,
        relationCode: "Self",
        name: globalUtils.isArabic(language)
          ? applicants.self.fullNameArabic
          : applicants.self.fullNameEnglish,
      },
      ...restApplicants,
    ],
    coverCode: travelDetails.productCode,
    languageCode: globalUtils.getOneLetterLanguageCode(language),
    deptDate: travelDetails.deptDate,
  };
};

export const buildFlightProposalRequest = (data, language) => {
  const { applicants, ...restData } = data;

  let passegers = [];
  if (applicants.applicants && applicants.applicants.length) {
    passegers = applicants.applicants.map((ele) => {
      return {
        idNumber: ele.nationalId,
        relationCode: "APT",
      };
    });
  }

  return {
    applicationRef: "SPFD",
    carrierFsCode: restData.carrierFsCode,
    coverOptionCode: null,
    departureDate: restData.departureDate,
    flightNumber: restData.flightNumber,
    lang: language,
    passengerList: [
      {
        idNumber: applicants.self.nationalId,
        relationCode: "APT",
      },
      ...passegers,
    ],
    proposalCode: null,
  };
};

export const buildTravelQoutationRequest = (
  data,
  language,
  homeInsurance,
  businessLine,
  duration
) => {
  console.log(businessLine, "lll");
  const { travelDetails, applicants, selectedFeatures } = data;
  const isLessThan180Days =
    moment(travelDetails.returnDate).diff(
      moment(travelDetails.deptDate),
      "d"
    ) <= 180;
  console.log(selectedFeatures);
  let mySelectedFeature = [
    {
      featureCode: "",
      featureDescription: null,
      featurePrice: null,
      price: null,
    },
  ];
  if (selectedFeatures && selectedFeatures.length) {
    mySelectedFeature = [];
    mySelectedFeature = selectedFeatures.reduce(
      (mySelectedFeature, selectedFeature) => {
        if (selectedFeature.featureCode !== "") {
          mySelectedFeature.push(selectedFeature);
        }
        return mySelectedFeature;
      },
      []
    );
    // mySelectedFeature = selectedFeatures.map((ele) => ele && ele.featureCode !== '' && ({
    //   featureCode: ele.featureCode,
    //   featureDescription: ele.featureDescription,
    //   featurePrice: ele.price,
    //   price: ele.price,
    // }));
  }

  return {
    productCode: isLessThan180Days ? "ST" : "AN",
    isTpremium: travelDetails.productCode === "US" && duration <= 180
    ? "Y"
    : "N",    coverCode: travelDetails.productFeatureCode,
    idNO: travelDetails.nationalId,
    tripDepartureDate: moment(travelDetails.deptDate).format("YYYY-MM-DD"),
    tripReturnDate: moment(travelDetails.returnDate).format("YYYY-MM-DD"),
    languageCode: globalUtils.getOneLetterLanguageCode(language),
    consumerTrackingId: travelDetails.nationalId,
    consumerInitiatedTimeStamp: new Date(),
    fursanID: travelDetails.alfursanId || "",
    FeatureDetails: mySelectedFeature,
    DependentsDetails: applicants.applicants.map((ele) => {
      return {
        // "relationship": "Wife",
        idNO: ele.nationalId,
        dOB: ele.dobGreg,
        firstNameinEnglish: ele.firstNameEnglish,
        middleNameinEnglish: ele.midNameEnglish,
        lastNameinEnglish: ele.lastNameEnglish,
        nationality: ele.nationalityCode,
        emailAddress: null,
        gender: ele.gender,
        occupation: ele.occupation,
        passportNumber: null,
      };
    }),
    AddressDetails: {
      additionalNumber: "2066898",
      addressCity: "5",
      addressRegion: "2",
      buildingNumber: "2526",
      district: "Al Faisaliyah Dist.",
      mailingAddress: "WA",
      poBox: "23442",
      postalCode: "23442",
      street: "Al Batha",
      unitNumber: null,
      waselPostalCode: "23442",
    },
    PromotionalFactors: [
      {
        promotionalCode: travelDetails.promoCode || "",
        UTMTag: "",
        openFieldOne: "",
        openFieldTwo: "",
      },
    ],
    promoCode: travelDetails.promoCode || "",
    returnCity: null,
    channelCode: businessLine ? "3" : "2",
    departureCity: null,
    ApplicantDetails: {
      idNO: applicants.self.nationalId,
      dOB: applicants.self.dobGreg,
      firstNameinEnglish: applicants.self.firstNameEnglish,
      middleNameinEnglish: applicants.self.midNameEnglish,
      lastNameinEnglish: applicants.self.lastNameEnglish,
      nationality: applicants.self.nationalityCode,
      gender: applicants.self.gender,
      emailAddress: travelDetails.email,
      mobileNumber: travelDetails.contactNumber,
      occupation: applicants.self.occupation,
      passportNumber: null,
      relationship: "self",
    },

    // politicianQuestions: {
    //   INCOME_SOURCE: "SALARY",
    //   pep_employer: "KING FAHAD ARME FORCE HOSPITAL",
    //   pep_yn: "N",
    //   PLACE_OF_BIRTH: "JEDDAH",
    //   WORK_PLACE: "JEDDAH",
    // },
  };
};

export const buildFlightQoutationRequest = (data, language) => {
  const { travelDetails, flightProposal, applicants, flightCovered } = data;

  console.log(travelDetails);
  const coveredItem = flightProposal?.quoteList?.find(
    (ele) => ele.periodCovered == flightCovered
  );
  return {
    fursanID: travelDetails.alfursanId || "",
    applicationRef: "SPFD",
    mapApprovalDoc: {
      qtnDetails: {
        AMLMatchStatus: null,
        applicantDetails: null,
        isPEPFlag: "0",
        isRoyalFamily: null,
        isTawuniyaBOD: null,
        LOB: null,
        payerDetails: null,
        payerFlag: null,
        PEPLink: null,
        policyHolderDetails: null,
        policyHolderSameFlag: null,
        quotationNum: null,
        RoyalFamilylink: null,
        TawuniyaBODlink: null,
      },
    },
    lang: language,
    passengerDetails: [
      {
        addressTyp: "WA",
        bankCode: travelDetails.bankCode || "",
        cityCode: "38",
        countryCode: "SA",
        dob: moment(applicants.self.dobGreg).format("DD/MM/YYYY"),
        email: travelDetails.email,
        employer: "Empty",
        firstName: applicants.self.firstNameEnglish,
        genderCode: applicants.self.gender,
        iban: travelDetails.iban || "",
        idNumber: applicants.self.nationalId,
        incomeSource: "Empty",
        lastName: applicants.self.lastNameEnglish,
        middleName: applicants.self.midNameEnglish,
        mobile: travelDetails.contactNumber,
        nationalityCode: applicants.self.nationalityCode,
        occupationCode: null,
        placeOfBirth: "Empty",
        poboxCode: "12345",
        politicalEmployer: null,
        politicalOccupation: null,
        politicalRank: null,
        politicalRelevantName: null,
        politicallyExposedCode: "0",
        postalCode: "12345",
        regionCode: "1",
        relationCode: "APT",
        ticketNumber: null,
      },
    ],
    proposalCode: flightProposal.proposalCode,
    quoteDetails: {
      arrivalAirportIataCode:
        flightProposal.flightDetalis.arrivalAirportIataCode,
      coverOptionCode: coveredItem.coverOptionCode,
      departureAirportIataCode:
        flightProposal.flightDetalis.departureAirportIataCode,
      periodCovered: flightCovered,
    },
  };
};

export const buildBundleQoutationRequest = (
  travelDetails,
  flightDelayQuotation,
  travelQuotation
) => {
  const flightTotal = flightDelayQuotation.paymentDetails.find(
    (ele) => ele.amountType === "GRNDTOT"
  );
  return {
    idNumber: travelDetails.nationalId,
    totalAmount: `${Number(
      +travelQuotation.GrandTotal + +flightTotal.amountValue
    ).toFixed(2)}`,
    quotes: [
      {
        quotationNumber: travelQuotation.QuotationNumber,
        amount: travelQuotation.GrandTotal,
        lob: "TR",
      },
      {
        quotationNumber: flightDelayQuotation.quotationCode,
        amount: flightTotal.amountValue,
        lob: "FD",
      },
    ],
  };
};
